/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-03-01, 11:58:48
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-06, 13:15:23
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import { API_URL } from '@/config';

import DownloadInvoice from '@/components/Common/DownloadInvoice';
import PagePaginationByLimitAndOffset from '@/components/Common/PagePaginationByLimitAndOffset';
import Card from '@/components/Common/Card';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'InvoicesAndCorrectionList',

  components: { DownloadInvoice, PagePaginationByLimitAndOffset, Card },

  props: ['customerInvoices', 'customerCorrectionInvoices', 'isLoading', 'acl'],

  data() {
    return {
      limit: 10,
      offset: 0,
      url: API_URL,
      totalNumberOfPages: 0,
      page: 0,
    };
  },

  computed: {
    actualPage() {
      return this.page;
    },
    numberOfPages() {
      return this.totalNumberOfPages;
    },
    downloadPayments() {
      return `${API_URL}/invoices/export`;
    },
  },
  methods: {
    pagesTotal(pages) {
      this.totalNumberOfPages = pages;
    },
    currentPage(page) {
      this.page = page;
    },
    nextPage(offset) {
      this.offset = offset;
    },
    prevPage(offset) {
      this.offset = offset;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/PaymentsAndInvoices/InvoicesAndCorrectionList/component.js